import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import Dashboard from "./routes/Dashboard";
import BehaviourConfiguration from "BehaviourConfiguration";
export default store => ({
  path: "behaviour-management",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "behaviour-management" */ "./components"),
      import(
        /* webpackChunkName: "behaviour-management" */ "./modules/BehaviourModule"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const behaviourReducer = importedModule1.default;
      const behaviourReducerName = importedModule1.NAME;

      injectReducer(store, {
        key: behaviourReducerName,
        reducer: behaviourReducer,
      });

      return component;
    })
  ),
  childRoutes: [Dashboard(store), BehaviourConfiguration(store)],
});
